import { RESPONSE_STATUSES } from '@/constants/enums';

export const LID_API_BASE_URL = import.meta.env.VITE_LID_API_BASE_URL;

export const SUCCESS_RESPONSE = {
  status: RESPONSE_STATUSES.SUCCESS,
};
